import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TEMPLATE_THEMES = "GET_LIST_TEMPLATE_THEMES";
export const SAVE_TEMPLATE_THEMES = "SAVE_TEMPLATE_THEMES";
export const DELETE_TEMPLATE_THEMES = "DELETE_TEMPLATE_THEMES";
export const SET_LIST_TEMPLATE_THEMES = "SET_LIST_TEMPLATE_THEMES";
export const GET_DETAIL_TEMPLATE_THEMES = "GET_DETAIL_TEMPLATE_THEMES";
export const UPDATE_TEMPLATE_THEMES = "UPDATE_TEMPLATE_THEMES";
export const SET_DETAIL_TEMPLATE_THEMES = "SET_DETAIL_TEMPLATE_THEMES";


const state = {
    listThemes: [],
    themeDetail: {}
};

const getters = {
    listThemes(state) {
        return state.listThemes;
    },
    themeDetail(state) {
        return state.themeDetail;
    },


};

const actions = {
    [GET_LIST_TEMPLATE_THEMES](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TEMPLATE_THEMES}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TEMPLATE_THEMES, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TEMPLATE_THEMES](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TEMPLATE_THEMES}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TEMPLATE_THEMES, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TEMPLATE_THEMES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TEMPLATE_THEMES}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TEMPLATE_THEMES](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_TEMPLATE_THEMES}/${payload.id}?_method=PUT`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TEMPLATE_THEMES](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TEMPLATE_THEMES}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TEMPLATE_THEMES](state, data) {
        state.listThemes = data.data;
    },
    [SET_DETAIL_TEMPLATE_THEMES](state, data) {
        state.themeDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};